import { Headers } from "enums";
import { ApiService } from "services/ApiService";
import { ApiUrl } from "services/ApiUrl";
import { LoginService } from "services/LoginService";
import qs from "qs";

const URL_API = ApiUrl.BASE;

const BandejaAprobacionAdministracionPersonalService = {
    async listarContratosPendientesAprobar() {
        const respuesta = await ApiService(URL_API).get(`/admin/contratos/administracion-personal/pendientes-aprobar`);
        return respuesta.data;
    },

    async aprobarContrato(data) {
        const respuesta = await ApiService(URL_API).post(`/admin/contratos/administracion-personal/aprobar`, data);
        return respuesta.data;
    },

    async rechazarContrato(data) {
        const respuesta = await ApiService(URL_API).post(`/admin/contratos/administracion-personal/rechazar`, data);
        return respuesta.data;
    },

    getUrlVistaPrevia(seguimientoContratoId) {
        const urlPdf =
            process.env.REACT_APP_ENDPOINT + `admin/contratos/administracion-personal/ver-pdf/${seguimientoContratoId}`;
        const httpHeaders = {
            Authorization: "Bearer " + LoginService.getJwtToken(),
            [Headers.ORGANIZACION_ID]: LoginService.getUsuarioAutenticado().organizacionId,
            [Headers.EMPRESA_ID]: LoginService.getUsuarioAutenticado().empresaSeleccionada.id,
        };

        return {
            url: urlPdf,
            httpHeaders: httpHeaders,
        };
    },
    async listarContratosPendientesAprobarAndFiltro(data) {
        const respuesta = await ApiService(URL_API).post(`admin/contratos/administracion-personal/pendientes-aprobar-filtro`, data);
        return respuesta.data;
    },
    async modificarContrato(data) {
        const respuesta = await ApiService(URL_API).post(`/admin/contratos/administracion-personal/modificarContrato`, data);
        return respuesta.data;
    },
    async actualizarResponsables(data) {
        const respuesta = await ApiService(URL_API).post(
            `/admin/contratos/administracion-personal/actualizarResponsables`,
            data,
            { responseType: "blob" }
        );
        return respuesta;
    },
    async notificarContratosPorVencerResponsables() {
        const respuesta = await ApiService(URL_API).get(`/admin/contratos/administracion-personal/notificar/contratos-por-vencer`);
        return respuesta.data;
    },
    async notificarContratosPorVencerResponsablesPorDNI(numeroDocumentoIdentidad) {
        const respuesta = await ApiService(URL_API).get(`/admin/contratos/administracion-personal/notificarPorDNI/contratos-por-vencer`, {
            params: { numeroDocumentoIdentidad }
        });
        return respuesta.data;
    },
    async renovarMasivamente(formData) {
        const respuesta = await ApiService(URL_API).post(
            `/admin/contratos/administracion-personal/renovar-masivamente`,
            formData,
            { responseType: "blob" }
        );
        return respuesta;
    },
    async retornarContratosRechazados(params) {
        const respuesta = await ApiService(URL_API).get(`admin/contratos/administracion-personal/retornar-contratos-rechazados`, {
          params: params,
          paramsSerializer: (params) => {
            return qs.stringify(params, { arrayFormat: "repeat" });
          },
        });
        return respuesta.data;
      },

    async retornarContratoActivo(params) {
        const respuesta = await ApiService(URL_API).get(`admin/contratos/administracion-personal/retornar-contrato-activo`, {
          params: params,
          paramsSerializer: (params) => {
            return qs.stringify(params, { arrayFormat: "repeat" });
          },
        });
        return respuesta.data;
      },
};

export { BandejaAprobacionAdministracionPersonalService };
